import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";

import Navbar from "./components/home/Navbar";
import Home from "./pages/Home";
import Services from "./components/home/Services"
import Contact from "./components/home/Contact";
import About from "./components/About";
import FAQ from "./components/home/FAQ";

// Ensures navigating to a new route (e.g. Home -> /services or /about) lands
// at the TOP of that page, instead of keeping the scroll position from the
// previous page. It skips this when a scrollTo target was requested (that
// case is handled by Home.jsx to jump straight to the section instead).
function ScrollToTop() {
  const location = useLocation();

  useLayoutEffect(() => {
    if (location.state?.scrollTo) return;
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
      </Routes>

    </BrowserRouter>
  );
}